import { FormattedMessage } from 'react-intl';
import { Schema } from 'src/utils/form';

export default Schema.object({
  riscos: Schema.array().label(''),
  exposicao: Schema.array().label(<FormattedMessage id="exposicao" />),
  categoriaDicionario: Schema.array().label(<FormattedMessage id="categoria" />),
  niveis: Schema.array().label(<FormattedMessage id="nivel" />),
  idIntegracao: Schema.string().label(<FormattedMessage id="codigo" />),
  nome: Schema.string().label(<FormattedMessage id="nome" />),
  responsaveis: Schema.array().label(''),
  areas: Schema.array().label(''),
  areasSubordinadas: Schema.boolean().label(''),
  matrizRisco: Schema.string().label(''),
  tipoRisco: Schema.string().label(''),
  modeloRisco: Schema.string().label(''),
  tags: Schema.array().label(''),
  classificacoesRisco: Schema.array().label(<FormattedMessage id="label.classificacao" />),
  status: Schema.string().label(<FormattedMessage id="status" />),
  desconsiderarStatusConcluido: Schema.boolean().label(''),
  desconsiderarStatusCancelado: Schema.boolean().label(''),
  causasRisco: Schema.array().label(''),
  consequenciasRisco: Schema.array().label(''),
  controles: Schema.array().label(''),
  processos: Schema.array().label(''),
  incluirSubprocessos: Schema.boolean().label(''),
  toleranciaRisco: Schema.array().label(''),
  toleranciaRiscoFaixas: Schema.array().label(''),
  camposCustomizados: Schema.array(),
});